export const setPermissaoAcesso = (permissaoAcesso) => ({
    type: 'SET_PERMISSAO_ACESSO',
    payload: { permissaoAcesso }
})